module.exports = __webpack_public_path__ + "img/data_py.371eab8c.png";